import { learningServiceRequest, skip } from "./utils";

const productLineService = {
  async getFinancialProductLines({ limit = 150, page = 1, q }) {
    return await learningServiceRequest({
      method: "get",
      url: "/financial_product_lines",
      params: {
        limit,
        skip: skip(page, limit),
        q,
      },
    });
  },
  async getSingleFinancialProductLine({ product_line_id = "" }) {
    return await learningServiceRequest({
      method: "get",
      url: `/financial_product_lines/${product_line_id}`,
      failureMessage: "Error loading Financial Product line data",
    });
  },
};

export default productLineService;
